export default __webpack_public_path__ + "c589ae62512e89f8a183fbedf00c0f4b.png";